<template>
  <div>
    <vs-popup :title="$t('ViewComment')" :active.sync="showModal">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="desc">
            {{ model.description }}
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mt-4">
          <vs-button
            color="danger"
            type="filled"
            class="float-right btn"
            icon-pack="feather"
            icon="icon-x"
            icon-before
            @click="reject()"
          >
            {{ $t("Reject") }}
          </vs-button>
          <vs-button
            color="success"
            type="filled"
            class="float-right btn ml-4"
            icon-pack="feather"
            icon="icon-check"
            icon-before
            @click="confirm()"
          >
            {{ $t("Confirm") }}
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.vs-button-filled {
  padding: 0.4rem 2rem !important;
}
.vs-button-filled i {
  margin-right: 0px !important;
  margin-left: 5px !important;
}
.desc {
  line-height: 1.75rem;
}
</style>

<script>
import { mapActions } from "vuex";

export default {
  name: " Content_managment_ProductComments_ModifyPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      info: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      commentStatus: "comment/update",
    }),
    reject() {
      this.info = {
        id: this.model.id,
        commentStatus: 2,
      };
      this.commentStatus(this.info).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت تعیین وضعیت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("finish");
        this.model = {};
      });
    },
    confirm() {
      this.info = {
        id: this.model.id,
        commentStatus: 1,
      };
      this.commentStatus(this.info).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت تعیین وضعیت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("finish");
        this.model = {};
      });
    },
  },
};
</script>
